import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import {
  findMatchingAssembly,
  getAssemblyPartProductRef,
  isAssemblyStructure,
  replaceAndSelectEntity
} from '../utils/assemblyUtils';

export const replaceFrame = ({ coreApi, props }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;

  if (isAssemblyStructure(selectedEntity)) {
    const underframeProductRef = getAssemblyPartProductRef(coreApi, selectedEntity, [
      ProductType.KALLAX_UNDERFRAME
    ]);
    if (!underframeProductRef) return;

    const matchingAssembly = findMatchingAssembly(
      coreApi,
      underframeProductRef,
      props.coreProductId
    );
    if (!matchingAssembly) return;

    replaceAndSelectEntity(coreApi, selectedEntity, matchingAssembly.id);
  } else {
    replaceAndSelectEntity(coreApi, selectedEntity, props.coreProductId);
  }
};
